export default __webpack_public_path__ + "static/media/ic-camera-modal.ce1a4a96.svg";